import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, TrendingUp, Brain } from 'lucide-react';

const highlights = [
  'Multi Timeframe',
  'Candlestick Analysis',
  'Trend Detection',
  'Support & Resistance',
  'Entry & Exit Points',
  'Stop Loss & Take Profit',
  'Risk Reward Ratio',
  'Confidence Score',
];

function HighlightFeature() {
  return (
    <section className="highlight-feature">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6" style={{ marginBottom: 40 }}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="highlight-feature__mockup">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Brain size={20} color="#0C8F86" />
                    <span style={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>AI Trading Analysis</span>
                  </div>
                  <span style={{
                    background: 'rgba(139,92,246,0.15)',
                    color: '#a78bfa',
                    fontSize: 10,
                    fontWeight: 700,
                    padding: '3px 10px',
                    borderRadius: 100,
                    border: '1px solid rgba(139,92,246,0.2)',
                  }}>
                    LIVE
                  </span>
                </div>

                <div style={{
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(255,255,255,0.06)',
                  borderRadius: 16,
                  padding: 20,
                  marginBottom: 16,
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                    <div>
                      <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11 }}>BBCA IDX</div>
                      <div style={{ color: '#fff', fontSize: 24, fontWeight: 700 }}>Rp 9.850</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ color: '#58bd7d', fontSize: 16, fontWeight: 700 }}>+2.34%</div>
                      <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11 }}>+Rp 225</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {[1, 2, 3, 4, 5, 6].map(i => (
                      <div key={i} style={{
                        flex: 1, height: 40,
                        borderRadius: 4,
                        background: i % 2 === 0 ? '#58bd7d' : '#ef4444',
                        opacity: 0.4 + (i / 10),
                        clipPath: 'polygon(25% 0%, 75% 0%, 100% 100%, 0% 100%)',
                      }} />
                    ))}
                  </div>
                </div>

                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                  <div style={{
                    flex: 1, minWidth: 100,
                    background: 'rgba(12,143,134,0.1)',
                    border: '1px solid rgba(12,143,134,0.15)',
                    borderRadius: 12,
                    padding: '12px 16px',
                  }}>
                    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 10, marginBottom: 4 }}>TREND</div>
                    <div style={{ color: '#58bd7d', fontSize: 14, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <TrendingUp size={14} /> Bullish
                    </div>
                  </div>
                  <div style={{
                    flex: 1, minWidth: 100,
                    background: 'rgba(139,92,246,0.1)',
                    border: '1px solid rgba(139,92,246,0.15)',
                    borderRadius: 12,
                    padding: '12px 16px',
                  }}>
                    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 10, marginBottom: 4 }}>CONFIDENCE</div>
                    <div style={{ color: '#a78bfa', fontSize: 14, fontWeight: 700 }}>87%</div>
                  </div>
                  <div style={{
                    flex: 1, minWidth: 100,
                    background: 'rgba(245,158,11,0.1)',
                    border: '1px solid rgba(245,158,11,0.15)',
                    borderRadius: 12,
                    padding: '12px 16px',
                  }}>
                    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 10, marginBottom: 4 }}>TIMEFRAME</div>
                    <div style={{ color: '#f59e0b', fontSize: 14, fontWeight: 700 }}>1H 4H 1D</div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="col-lg-6">
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="section-label">
                <Brain size={14} />
                AI Feature
              </div>

              <h2 style={{
                fontSize: 36,
                fontWeight: 700,
                color: 'var(--onsurface)',
                lineHeight: 1.2,
                marginBottom: 16,
                letterSpacing: '-1px',
              }}>
                AI Trading Analysis
              </h2>

              <p style={{
                fontSize: 16,
                color: 'var(--text)',
                lineHeight: 1.8,
                marginBottom: 28,
                maxWidth: 480,
              }}>
                Upload screenshot chart dan AI akan memberikan analisis lengkap dengan akurasi tinggi. Dapatkan rekomendasi entry, exit, stop loss, dan risk reward secara instan.
              </p>

              <div className="row" style={{ marginBottom: 32 }}>
                {highlights.map((item, i) => (
                  <div className="col-6" key={i} style={{ marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{
                        width: 20, height: 20, borderRadius: '50%',
                        background: 'rgba(12,143,134,0.1)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <Check size={12} color="#0C8F86" />
                      </span>
                      <span style={{ fontSize: 14, color: 'var(--onsurface)', fontWeight: 500 }}>{item}</span>
                    </div>
                  </div>
                ))}
              </div>

              <button className="final-cta__btn-primary" onClick={() => window.open('https://app.tradiora.id', '_blank')}>
                Coba Sekarang <ArrowRight size={16} />
              </button>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HighlightFeature;
